// extracted by mini-css-extract-plugin
export default {"loading__img":"LoadingElement_loading__img__ZbJuH"};